module.exports = __webpack_public_path__ + "media/V66.a3ffa64a.mp4";